/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getServiceProviderBillingCsv } from '../fn/service-provider/get-service-provider-billing-csv';
import { GetServiceProviderBillingCsv$Params } from '../fn/service-provider/get-service-provider-billing-csv';
import { getServiceProviderBillingCsvGroupedBySite } from '../fn/service-provider/get-service-provider-billing-csv-grouped-by-site';
import { GetServiceProviderBillingCsvGroupedBySite$Params } from '../fn/service-provider/get-service-provider-billing-csv-grouped-by-site';
import { getServiceProviderBillingCsvGroupedBySiteTimestamp } from '../fn/service-provider/get-service-provider-billing-csv-grouped-by-site-timestamp';
import { GetServiceProviderBillingCsvGroupedBySiteTimestamp$Params } from '../fn/service-provider/get-service-provider-billing-csv-grouped-by-site-timestamp';
import { getServiceProviderOrganizations } from '../fn/service-provider/get-service-provider-organizations';
import { GetServiceProviderOrganizations$Params } from '../fn/service-provider/get-service-provider-organizations';
import { Organization } from '../models/organization';
import { OrganizationsForServiceProvider } from '../models/organizations-for-service-provider';
import { patchServiceProviderOrganization } from '../fn/service-provider/patch-service-provider-organization';
import { PatchServiceProviderOrganization$Params } from '../fn/service-provider/patch-service-provider-organization';
import { postServiceProviderOrganization } from '../fn/service-provider/post-service-provider-organization';
import { PostServiceProviderOrganization$Params } from '../fn/service-provider/post-service-provider-organization';


/**
 * Service provider operations including announcement management and organization administration
 */
@Injectable({ providedIn: 'root' })
export class ServiceProviderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getServiceProviderOrganizations()` */
  static readonly GetServiceProviderOrganizationsPath = '/service-provider/organizations';

  /**
   * get list of all organizations on the platform.
   *
   * Get a list of all organizations that are on the platform.
   * The quotas are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderOrganizations$Response(params?: GetServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationsForServiceProvider>> {
    const obs = getServiceProviderOrganizations(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * get list of all organizations on the platform.
   *
   * Get a list of all organizations that are on the platform.
   * The quotas are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderOrganizations(params?: GetServiceProviderOrganizations$Params, context?: HttpContext): Observable<OrganizationsForServiceProvider> {
    const resp = this.getServiceProviderOrganizations$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationsForServiceProvider>): OrganizationsForServiceProvider => r.body)
    );
  }

  /** Path part for operation `postServiceProviderOrganization()` */
  static readonly PostServiceProviderOrganizationPath = '/service-provider/organizations';

  /**
   * Create organization.
   *
   * Create a new organization and the first admin for this organization.
   * This endpoint is for the service provider.
   * The quotas are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postServiceProviderOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderOrganization$Response(params: PostServiceProviderOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<Organization>> {
    const obs = postServiceProviderOrganization(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create organization.
   *
   * Create a new organization and the first admin for this organization.
   * This endpoint is for the service provider.
   * The quotas are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postServiceProviderOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderOrganization(params: PostServiceProviderOrganization$Params, context?: HttpContext): Observable<Organization> {
    const resp = this.postServiceProviderOrganization$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Organization>): Organization => r.body)
    );
  }

  /** Path part for operation `patchServiceProviderOrganization()` */
  static readonly PatchServiceProviderOrganizationPath = '/service-provider/organizations/{organizationKey}';

  /**
   * Update organization.
   *
   * Update a organization. All properties are optional.
   * The property phone numbers is replaced with the new property.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchServiceProviderOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderOrganization$Response(params: PatchServiceProviderOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = patchServiceProviderOrganization(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update organization.
   *
   * Update a organization. All properties are optional.
   * The property phone numbers is replaced with the new property.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchServiceProviderOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderOrganization(params: PatchServiceProviderOrganization$Params, context?: HttpContext): Observable<void> {
    const resp = this.patchServiceProviderOrganization$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getServiceProviderBillingCsv()` */
  static readonly GetServiceProviderBillingCsvPath = '/service-provider/billing/csv';

  /**
   * Get billing CSV.
   *
   * Get billing CSV for a specified timeframe.
   * From and to must have millisecond resolution.
   * Constrain: from <= timestamp < to
   * All times are in UTC.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderBillingCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsv$Response(params: GetServiceProviderBillingCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getServiceProviderBillingCsv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get billing CSV.
   *
   * Get billing CSV for a specified timeframe.
   * From and to must have millisecond resolution.
   * Constrain: from <= timestamp < to
   * All times are in UTC.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderBillingCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsv(params: GetServiceProviderBillingCsv$Params, context?: HttpContext): Observable<string> {
    const resp = this.getServiceProviderBillingCsv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getServiceProviderBillingCsvGroupedBySiteTimestamp()` */
  static readonly GetServiceProviderBillingCsvGroupedBySiteTimestampPath = '/service-provider/billing/csv-grouped-by-site/timestamp';

  /**
   * Get billing CSV grouped by site transactions for a year and month.
   *
   * Get billing CSV for a specified timestamp grouped by organization sites.
   * All times are in UTC.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderBillingCsvGroupedBySiteTimestamp()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsvGroupedBySiteTimestamp$Response(params: GetServiceProviderBillingCsvGroupedBySiteTimestamp$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getServiceProviderBillingCsvGroupedBySiteTimestamp(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get billing CSV grouped by site transactions for a year and month.
   *
   * Get billing CSV for a specified timestamp grouped by organization sites.
   * All times are in UTC.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderBillingCsvGroupedBySiteTimestamp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsvGroupedBySiteTimestamp(params: GetServiceProviderBillingCsvGroupedBySiteTimestamp$Params, context?: HttpContext): Observable<string> {
    const resp = this.getServiceProviderBillingCsvGroupedBySiteTimestamp$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getServiceProviderBillingCsvGroupedBySite()` */
  static readonly GetServiceProviderBillingCsvGroupedBySitePath = '/service-provider/billing/csv-grouped-by-site/timeframe';

  /**
   * Get billing CSV grouped by site transactions.
   *
   * Get billing CSV for a specified timeframe grouped by organization sites.
   * From and to must have millisecond resolution.
   * Constrain: from <= timestamp < to
   * All times are in UTC.
   * The maximum range between from and to is 35 days.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderBillingCsvGroupedBySite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsvGroupedBySite$Response(params: GetServiceProviderBillingCsvGroupedBySite$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = getServiceProviderBillingCsvGroupedBySite(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get billing CSV grouped by site transactions.
   *
   * Get billing CSV for a specified timeframe grouped by organization sites.
   * From and to must have millisecond resolution.
   * Constrain: from <= timestamp < to
   * All times are in UTC.
   * The maximum range between from and to is 35 days.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderBillingCsvGroupedBySite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderBillingCsvGroupedBySite(params: GetServiceProviderBillingCsvGroupedBySite$Params, context?: HttpContext): Observable<string> {
    const resp = this.getServiceProviderBillingCsvGroupedBySite$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
